<template>
  <div class="tr-page-wrap">
    <div class="page3">
      <div class="content-box bg-none tab-cont-wrap">
        <div class="tabCont print-page">
      <div class="content-inner-box" v-show="false">
        <div class="tit-group ty01">
          <h4 class="tit">{{monitoringInfo.monitoringTitle}}</h4>
          <c-btnLine01 :btnText="'다운로드테스트'" class="sm ty03" @click="onClickDownloadReport" v-if="user.roles == 'ADMIN1'"/>
        </div>
        <div class="tit-group02 inner-ty">
          <h2 class="tit"></h2>
          <div class="filter-btn-group">
            <v-btn class="reset" :class="filterDiv1" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
            <v-btn class="filter" @click="filterOpen1" :class="filterDiv1">{{t('message.filter')}}</v-btn>
          </div>
        </div>
        <div class="sort-group ty01" :class="filterDiv1">
          <div class="sort-row">
            <div class="wl">
              <div class="date-sort">
                <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
                <div class="txt02">~</div>
                <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
              </div>
              <div class="date-sort">
                <c-btn02 :btnText="t('message.currentMonth')" class="ty01" @click="onClickDate('month')"/>
                <c-btn02 :btnText="t('message.quarter')" class="ty01" @click="onClickDate('quarter')"/>
                <c-btn02 :btnText="t('message.year2')" class="ty01" @click="onClickDate('year')"/>
              </div>
            </div>
          </div>
          <div class="sort-row">
            <div class="wl">
              <Select v-bind="memberSelect" v-model="memberModel"/>
              <Select v-bind="deptSelect" v-model="deptModel"/>
              <Select v-bind="posSelect" v-model="posModel"/>
              <Select v-bind="shiftSelect" v-model="shiftModel"/>
              <Select v-bind="monitoringSelect" v-model="monitoringModel"/>
            </div>
          </div>
        </div>
      </div>
      <!--row-->
      <div class="tit-group02 ty02 mo-ty02">
        <h2 class="tit">{{t('message.simpleReport')}}</h2>
      </div>
      <div class="content-inner-box ty01">
        <div class="tit-group ty01">
          <h4 class="tit">{{t('message.quickKPI')}}</h4>
        </div>
        <div class="card-group02 ty02">
          <!--card-item-->
          <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryFrequency=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryFrequency"
                          @click.stop="onClickUpdateDisplay('summaryFrequency',reportDisplayInfo.summaryFrequency)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ allAnswerCnt }}</div>
                </div>
                <div class="txt2">{{t('message.participationFrequency')}}</div>
              </div>
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ periodAnswerCnt }}</div>
                </div>
                <div class="txt2">{{t('message.goalAchievement')}}</div>
              </div>
            </div>
          </div>
          <!--card-item-->
          <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryRate=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryRate"
                          @click.stop="onClickUpdateDisplay('summaryRate',reportDisplayInfo.summaryRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ allAnswerPercent }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.participationRate')}}</div>
              </div>
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ periodAnswerPercent }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.goalAchievementRate')}}</div>
              </div>
            </div>
          </div>
          <!--card-item-->
          <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineRate=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryTimelineRate"
                          @click.stop="onClickUpdateDisplay('summaryTimelineRate',reportDisplayInfo.summaryTimelineRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ timelineTy1Cnt }}</div>
                </div>
                <div class="txt2">{{t('message.correctiveActionCompleted')}}</div>
              </div>
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ timelineTy1Percent }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.correctiveActionCompletionRate')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-group02 ty02 c-ty01">
          <!--card-item-->
          <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineAll=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryTimelineAll"
                          @click.stop="onClickUpdateDisplay('summaryTimelineAll',reportDisplayInfo.summaryTimelineAll)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ timelineAllRate }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.safetyTalkParticipationRate')}}</div>
              </div>
            </div>
          </div>
          <!--card-item-->
          <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineType1=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryTimelineType1"
                          @click.stop="onClickUpdateDisplay('summaryTimelineType1',reportDisplayInfo.summaryTimelineType1)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ timelineTy1Rate }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.correctiveFeedbackImplementationRate')}}</div>
              </div>
            </div>
          </div>
          <!--card-item-->
          <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineType2=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryTimelineType2"
                          @click.stop="onClickUpdateDisplay('summaryTimelineType2',reportDisplayInfo.summaryTimelineType2)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ timelineTy2Rate }}<span>%</span></div>
                </div>
                <div class="txt2">{{t('message.supportiveFeedbackImplementationRate')}}</div>
              </div>
            </div>
          </div>
          <!--card-item-->
          <div class="card-col-wrap ty02" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineReceive=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryTimelineReceive"
                          @click.stop="onClickUpdateDisplay('summaryTimelineReceive',reportDisplayInfo.summaryTimelineReceive)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="card-col ty05">
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ myTimelineTy1Cnt }}</div>
                </div>
                <div class="txt2">{{t('message.correctiveFeedbackReceived')}}</div>
              </div>
              <div class="txt-group">
                <div class="inner">
                  <div class="txt1">{{ myTimelineTy2Cnt }}</div>
                </div>
                <div class="txt2">{{t('message.supportiveFeedbackReceived')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-group02 ty03">
          <div class="card-col" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryMemberTop=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryMemberTop"
                          @click.stop="onClickUpdateDisplay('summaryMemberTop',reportDisplayInfo.summaryMemberTop)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="tit">
              {{t('message.activityLeaderOfTheMonth')}}
              <c-tooltip :TooltipText="t('message.currentMonthTopPerformerLabel')"/>

            </div>
            <v-carousel
              hide-delimiters
              height="auto"
              :continuous="false"
            >
              <v-carousel-item
                v-for="(item, i) in memberAnswerList"
                :key="'memberAnswerList_'+item.idx"
              >
                <div class="txt1">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
                <div class="txt2">
                  <span>{{t('message.monitoring')}} <span>{{ item.allAnswerCnt }}{{t('message.countUnit')}}</span></span>
                  <span>{{t('message.safetyTalk')}} <span>{{ item.timelineTy1Cnt + item.timelineTy2Cnt }}{{t('message.countUnit')}}</span></span>
                </div>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div class="card-col" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryMemberBottom=='Y')">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.summaryMemberBottom"
                          @click.stop="onClickUpdateDisplay('summaryMemberBottom',reportDisplayInfo.summaryMemberBottom)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <div class="tit">
              {{t('message.activityLaggardOfTheMonth')}}
              <c-tooltip :TooltipText="t('message.currentMonthLowPerformerLabel')"/>

            </div>
            <v-carousel
              hide-delimiters
              height="auto"
              :continuous="false"
            >
              <v-carousel-item
                v-for="(item, i) in memberAnswerListReverse"
                :key="'memberAnswerListReverse_'+item.idx"
              >
                <div class="txt1">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
                <div class="txt2">
                  <span>{{t('message.monitoring')}} <span>{{ item.allAnswerCnt }}{{t('message.countUnit')}}</span></span>
                  <span>{{t('message.safetyTalk')}} <span>{{ item.timelineTy1Cnt + item.timelineTy2Cnt }}{{t('message.countUnit')}}</span></span>
                </div>
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
      </div>
      <!--row-->
      <div class="content-inner-box ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineFrequencyRate=='Y')">
        <div class="tit-group ty01">
          <h4 class="tit">{{t('message.participationRate')}}</h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.lineFrequencyRate"
                          @click.stop="onClickUpdateDisplay('lineFrequencyRate',reportDisplayInfo.lineFrequencyRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <Select v-bind="periodSelect" v-model="frequencyRatePeriodModel"/>
            <Select v-bind="rateTypeSelect" v-model="frequencyRateTypeModel"/>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group">
          <Line :data="frequencyRateLineData" :options="options_line" />
        </div>
      </div>
      <!--row-->
      <div class="content-inner-box ty01">
        <div class="tit-group ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineBehaviorRate=='Y')">
          <h4 class="tit">{{t('message.safetyBehaviorRate')}}</h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.lineBehaviorRate"
                          @click.stop="onClickUpdateDisplay('lineBehaviorRate',reportDisplayInfo.lineBehaviorRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <Select v-bind="periodSelect" v-model="behaviorRatePeriodModel"/>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineBehaviorRate=='Y')">
          <Line :data="behaviorRateLineData" :options="options_line" />
        </div>
        <div class="cont-row" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.barBehaviorRate=='Y')">
          <div class="tit-group ty01">
            <h4 class="tit02">{{t('message.safetyBehaviorRateByCategory')}}</h4>
            <div class="wr">
              <div class="check-group ty02 mo-none">
                <v-checkbox :label="t('message.isVisible')"
                            v-if="user.roles != 'USER'"
                            v-model="reportDisplayInfo.barBehaviorRate"
                            @click.stop="onClickUpdateDisplay('barBehaviorRate',reportDisplayInfo.barBehaviorRate)"
                            true-value="Y" false-value="N"></v-checkbox>
              </div>
            </div>
          </div>
          <!--그래프 위치-->
          <div class="graph-group">
            <div class="graph-txt">
              <div class="txt"
                   v-for="(item, i) in behaviorStep1BarData.labelsObj"
                   :key="i">
                <button @click="apiReportBehaviorRate('behavior', item.categoryIdx, '')">{{item.label}}</button>
              </div>
            </div>
            <div class="graph-cont">
              <Bar :key="chartKey(1)" :data="behaviorStep1BarData" :options="options_bar1" ref="behaviorStep1Bar"/>
            </div>
          </div>
        </div>
        <div class="cont-row" v-if="behaviorStep2BarData.labelsObj">
          <div class="tit-group ty01">
            <h4 class="tit02">
              {{t('message.safetyBehaviorRateByObservationItem')}}
              <span class="sub-txt">
              {{t('message.clickObservationItemToViewDetails')}}
            </span>
            </h4>
            <div class="wr">
              <div class="check-group ty02 mo-none">
                <v-checkbox :label="t('message.isVisible')"></v-checkbox>
              </div>
            </div>
          </div>
          <!--그래프 위치-->
          <div class="graph-group">
            <div class="graph-txt">
              <div class="txt"
                   v-for="(item, i) in behaviorStep2BarData.labelsObj"
                   :key="i">
                <button @click="apiReportBehaviorRate('comment', item.categoryIdx, item.behaviorIdx)">{{item.label}}</button>
              </div>
            </div>
            <div class="graph-cont">
              <Bar :key="chartKey(2)" :data="behaviorStep2BarData" :options="options_bar2" ref="behaviorStep2Bar"/>
            </div>
          </div>
        </div>
        <div class="cont-row" v-if="behaviorStep3BarData.labelsObj">
          <div class="tit-group ty01">
            <h4 class="tit02">
              {{t('message.safetyBehaviorRateByDetailedObservationItem')}}
            </h4>
            <div class="wr">
              <div class="check-group ty02 mo-none">
                <v-checkbox :label="t('message.isVisible')"></v-checkbox>
              </div>
            </div>
          </div>
          <!--그래프 위치-->
          <div class="graph-group">
            <div class="graph-txt">
              <div class="txt"
                   v-for="(item, i) in behaviorStep3BarData.labelsObj"
                   :key="i">
                <button>{{item.label}}</button>
              </div>
            </div>
            <div class="graph-cont">
              <Bar :key="chartKey(3)" :data="behaviorStep3BarData" :options="options_bar" />
            </div>
          </div>
        </div>
      </div>
      <!--row-->
      <div class="content-inner-box ty01">
        <div class="tit-group ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineTimelineRate=='Y')">
          <h4 class="tit">{{t('message.safetyTalkImplementationRate')}}
            <c-tooltip :TooltipText="t('message.whyAllResultsAre100Percent')"/>
          </h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.lineTimelineRate"
                          @click.stop="onClickUpdateDisplay('lineTimelineRate',reportDisplayInfo.lineTimelineRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <Select v-bind="periodSelect" v-model="timelineRatePeriodModel"/>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineTimelineRate=='Y')">
          <Line :data="timelineRateLineData" :options="options_line" />
        </div>
        <div class="cont-row mo-none" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.listTimelineBehavior=='Y')">
          <div class="tit-group ty01">
            <h4 class="tit">{{t('message.safetyTalkActivityDetails')}}</h4>
            <div class="wr">
              <div class="check-group ty02">
                <v-checkbox :label="t('message.isVisible')"
                            v-if="user.roles != 'USER'"
                            v-model="reportDisplayInfo.listTimelineBehavior"
                            @click.stop="onClickUpdateDisplay('listTimelineBehavior',reportDisplayInfo.listTimelineBehavior)"
                            true-value="Y" false-value="N"></v-checkbox>
              </div>
            </div>
          </div>
          <!--그래프 위치-->
          <div class="tbl-group size-custom14">
            <v-data-table
              :headers="headers"
              :items="timelineBehaviorItems"
              return-object
            >
              <template v-slot:item.action="{ item }" >
                <div class="ell01">
                  {{item.action}}
                </div>
              </template>
              <template v-slot:item.detailView="{ item }">
                <div class="flex-c">
                  <BtnIcon class="btn-ico-search" @click="onClickTimelineBehaviorDialog(item.behaviorIdx)"/>
                </div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
      <!--row-->
      <div class="content-inner-box ty01 mo-none" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.listMemberActivity=='Y')">
        <div class="tit-group ty01">
          <h4 class="tit">{{t('message.individualActivityDetails')}}
            <div class="sub-txt02">
              <div class="col">
                {{t('message.totalParticipationCount')}} <span>{{behaviorStep3Cnt}}{{t('message.countUnit')}}</span>
              </div>
              <div class="line"></div>
              <div class="col">
                {{t('message.totalParticipationRate')}} <span>{{ behaviorStep3Rate }}%</span>
              </div>
            </div>
          </h4>
          <div class="wr">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.listMemberActivity"
                          @click.stop="onClickUpdateDisplay('listMemberActivity',reportDisplayInfo.listMemberActivity)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="tbl-group size-custom15">
          <v-data-table
            :headers="headers2"
            :items="memberActivityItems"
            return-object
          >
            <template v-slot:item.author="{ item }" >
              <div class="ell01">
                {{item.author}}
              </div>
            </template>
            <template v-slot:item.detailView="{ item }">
              <div class="flex-c">
                <BtnIcon class="btn-ico-search" @click="onClickMemberActivityDialog(item.memberIdx)"/>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, onMounted, ref, watch} from 'vue';
import AuthService from "@/services/auth.service";
import BbsService from "@/services/bbs.service";
import BatchService from "@/services/batch.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, PointElement, LineElement, CategoryScale, LinearScale } from 'chart.js'
import { Line, Bar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as XLSX from 'xlsx'
import html2canvas from 'html2canvas';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//plugin
dayjs.extend(quarterOfYear)
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, ChartDataLabels)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//bind
const snackbar = ref(false)
const snackText = ref('')
//let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value
let viewCompanyIdx = route.params.companyIdx
let viewMemberId = route.params.memberId
const timelineBehaviorDialogModel = ref(false)
const memberActivityDialogModel = ref(false)
const startDate = ref('')
const endDate = ref('')
const memberModel = ref('c')
const deptModel = ref('')
const posModel = ref('')
const shiftModel = ref('')
const monitoringModel = ref('')
const monitoringInfo:any = ref({})
const reportDisplayInfo:any = ref({})
const periodAnswerCnt = ref(0)
const allAnswerCnt = ref(0)
const periodAnswerPercent = ref(0)
const allAnswerPercent = ref(0)
const timelineTy1Cnt = ref(0)
const timelineTy1Percent = ref(0)
const timelineAllRate = ref(0)
const timelineTy1Rate = ref(0)
const timelineTy2Rate = ref(0)
const myTimelineTy1Cnt = ref(0)
const myTimelineTy2Cnt = ref(0)
const memberAnswerList = ref([])
const memberAnswerListReverse = ref([])
const frequencyRatePeriodModel = ref('week')
const frequencyRateTypeModel = ref('1')
const behaviorRatePeriodModel = ref('week')
const timelineRatePeriodModel = ref('week')
const timelineBehaviorItems:any = ref([])
const memberActivityItems:any = ref([])
const frequencyRateLineData:any = ref({labels: [], datasets: []})
const behaviorRateLineData:any = ref({labels: [], datasets: []})
const timelineRateLineData:any = ref({labels: [], datasets: []})
const behaviorStep1BarData:any = ref({labels: [], datasets: []})
const behaviorStep1Bar:any = ref<HTMLInputElement | null>(null)
const behaviorStep2BarData:any = ref({labels: [], datasets: []})
const behaviorStep2Bar:any = ref<HTMLInputElement | null>(null)
const behaviorStep3BarData:any = ref({labels: [], datasets: []})
const behaviorStep3Cnt = ref(0)
const behaviorStep3Rate = ref(0)
let searchParams:any = {}
const user:any = {roles:"ADMIN3"}
window.renderDone = false
let loadingCnt = 0
let doneTimer = null

//define
const props = defineProps({isActive: Boolean})

//ui
const memberSelect = ref({items: [{name:t('message.individualViewUnit'), value:'m'},{name:t('message.departmentViewUnit'), value:'c'}]})
const deptSelect = ref({items: [{name:t('message.department'), value:''}]})
const posSelect = ref({items: [{name:t('message.position'), value:''}]})
const shiftSelect = ref({items: [{name: t('message.shiftWork'), value: ''}]} )
const monitoringSelect = ref({items: [{name:t('message.monitoringAll'), value:''}]})
const periodSelect = ref({items: [{name:t('message.week'), value:'week'},{name:t('message.month'), value:'month'}]})
const rateTypeSelect = ref({items: [{name:t('message.participationFrequency'), value:'1'},{name:t('message.frequencyAchievementRate'), value:'2'}]})

//ui
const headers = ref([

  { title: t('message.behavior'), key: 'action' },
  { title: t('message.safetyTalk'), key: 'safetyTalk' },
  { title: t('message.praiseTalk'), key: 'cheerTalk' },
  { title: t('message.detailedContent'), key: 'detailView' },
])
const headers2 = ref([

  { title: t('message.author'), key: 'author' },
  { title: t('message.monitoring'), key: 'monitoring' },
  { title: t('message.safetyTalk'), key: 'safetyTalk' },
  { title: t('message.lastSubmissionDate'), key: 'submit' },
  { title: t('message.detailedContent'), key: 'detailView' },
])
const options_line:any = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 30
    }
  },
  clip: false,
  scales: {
    x: {
      title: {
        display: true,
        text: ''
      }
    },
    y: {
      title: {
        display: true,
        text: ''
      },
      min: 0,
      max: 100,
      ticks: {
        stepSize: 20
      },
      display:false
    },
  },
  plugins: {
    legend: {
      usePointStyle: true,
      position: 'bottom'
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const value = context.parsed.y; // y축 값
          return `${value}%`; // 뒤에 % 붙이기
        }
      }
    },
    datalabels: {
      anchor: 'center',  // 텍스트 위치 (start, center, end)
      align: 'top',   // 정렬 (top, bottom, middle)
      formatter: (value) => `${value}%`, // 데이터 값 표시
      font: {
        weight: 'bold'
      }
    }
  },
  animation: {
    onComplete: () => {
    }
  }
}
const options_bar:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const value = context.parsed.x; // y축 값
          return `${value}%`; // 뒤에 % 붙이기
        }
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  },
  animation: {
    onComplete: () => {
    }
  }
}
const options_bar1:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const value = context.parsed.x; // y축 값
          return `${value}%`; // 뒤에 % 붙이기
        }
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  },
  animation: {
    onComplete: () => {
    }
  },
  onClick: (e) => {
    const chart = behaviorStep1Bar.value.chart;
    const event = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false)
    const categoryIdx = behaviorStep1BarData.value.labelsObj.at(event.at(0).index).categoryIdx
    apiReportBehaviorRate('behavior', categoryIdx, '')
  }
}
const options_bar2:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const value = context.parsed.x; // y축 값
          return `${value}%`; // 뒤에 % 붙이기
        }
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  },
  animation: {
    onComplete: async () => {
      await nextTick()
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          loadingCnt++
          if(loadingCnt == 1) {
            console.log('loadingCnt 1:'+behaviorStep2BarData.value.labels.length)
            window.renderDone = true
            /*
            doneTimer = setTimeout(() => {
              window.renderDone = true
            }, 9000)
             */
          }
        })
      })
    }
  },
  onClick: (e) => {
    const chart = behaviorStep2Bar.value.chart;
    const event = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false)
    const categoryIdx = behaviorStep2BarData.value.labelsObj.at(event.at(0).index).categoryIdx
    const behaviorIdx = behaviorStep2BarData.value.labelsObj.at(event.at(0).index).behaviorIdx
    apiReportBehaviorRate('comment', categoryIdx, behaviorIdx)
  }
}

//hook
onMounted(async () => {
  window.renderDone = false
  await tempLogin()
  firstLoading()
})

//computed
const chartKey = computed(()=>(param) => {
  if(param==1)
    return JSON.stringify(behaviorStep1BarData.value)
  else if(param==2)
    return JSON.stringify(behaviorStep2BarData.value)
  else
    return JSON.stringify(behaviorStep3BarData.value)
})

//function
const tempLogin=async()=>{
  try {
    const params = {
      memberId:viewMemberId,
      password:viewMemberId,
      tempYn:'Y'
    }
    const response = await AuthService.login(params)
  }
  catch(error){
    snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    snackbar.value = true
  }
}

const apiReportSummary=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:'',
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    isExclude:'N',
    companyIdx:viewCompanyIdx
  }
  //summary
  BbsService.getBbsReportSummary(params).then(
    (response) => {
      periodAnswerCnt.value = response.result.periodAnswerCnt
      allAnswerCnt.value = response.result.allAnswerCnt
      periodAnswerPercent.value = response.result.periodAnswerPercent
      allAnswerPercent.value = response.result.allAnswerPercent
      timelineTy1Cnt.value = response.result.timelineTy1Cnt
      timelineTy1Percent.value = response.result.timelineTy1Percent
      timelineAllRate.value = response.result.timelineAllRate
      timelineTy1Rate.value = response.result.timelineTy1Rate
      timelineTy2Rate.value = response.result.timelineTy2Rate
      myTimelineTy1Cnt.value = response.result.myTimelineTy1Cnt
      myTimelineTy2Cnt.value = response.result.myTimelineTy2Cnt
      memberAnswerList.value = response.result.memberAnswerList
      _.forEach(memberAnswerList.value, (val, key)=>{
        val.activityCnt = val.allAnswerCnt+val.timelineTy1Cnt+val.timelineTy2Cnt
      })
      memberAnswerList.value = _.sortBy(memberAnswerList.value, 'activityCnt')
      memberAnswerListReverse.value = _.sortBy(memberAnswerList.value, 'activityCnt').reverse()
      memberAnswerList.value = _.slice(memberAnswerList.value, 0, 3)
      memberAnswerListReverse.value = _.slice(memberAnswerListReverse.value, 0, 3)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiReportRate=(type)=>{
  let typeParam = frequencyRatePeriodModel.value
  if(type == 'behavior')
    typeParam = behaviorRatePeriodModel.value
  else if(type == 'timeline')
    typeParam = timelineRatePeriodModel.value
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:'',
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    periodRateType:typeParam,
    isExclude:'N',
    companyIdx:viewCompanyIdx
  }
  //참여율정보
  BbsService.getBbsReportRate(params).then(
    (response) => {
      if(type == '' || type == 'frequency'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          if(frequencyRatePeriodModel.value == 'week')
            labels.push(val.startDate)
          else
            labels.push(val.answerDate)
          if(val.answerCntNormal == 0 || val.periodCntNormal == 0)
            normalData.push(0)
          else
            normalData.push(val.answerCntNormal<=val.periodCntNormal?Math.round(val.answerCntNormal / val.periodCntNormal * 100):100)
          if(val.answerCntAudit == 0 || val.periodCntAudit == 0)
            auditData.push(0)
          else
            auditData.push(val.answerCntAudit<=val.periodCntAudit?Math.round(val.answerCntAudit / val.periodCntAudit * 100):100)
        })
        frequencyRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.participationRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData,
            },
            {
              label: t('message.auditParticipationRate'),
              borderColor: '#A155B9',
              backgroundColor: '#A155B9',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: auditData
            }
          ]
        }
      }
      if(type == '' || type == 'behavior'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          if(behaviorRatePeriodModel.value == 'week')
            labels.push(val.startDate)
          else
            labels.push(val.answerDate)
          normalData.push(Math.round(val.scoreNormal))
          auditData.push(Math.round(val.scoreAudit))
        })
        behaviorRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.safetyBehaviorRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData,
            },
            {
              label: t('message.auditSafetyBehaviorRate'),
              borderColor: '#A155B9',
              backgroundColor: '#A155B9',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: auditData
            }
          ]
        }
      }
      if(type == '' || type == 'timeline'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          if(timelineRatePeriodModel.value == 'week')
            labels.push(val.startDate)
          else
            labels.push(val.answerDate)

          //timeline은 라인이 한개라 서버에서는 분리해서 주지만 화면에서 normal+audit으로 계산함
          const timelineCnt = val.timelineCntNormal??0 + val.timelineCntAudit??0
          const periodCnt = val.periodCntNormal??0 + val.periodCntAudit??0
          if(timelineCnt == 0 || periodCnt == 0)
            normalData.push(0)
          else
            normalData.push(Math.round(timelineCnt / periodCnt * 100) > 100 ? 100 : Math.round(timelineCnt / periodCnt * 100))
          /*
          if(val.timelineCntNormal == 0 || val.periodCntNormal == 0)
            normalData.push(0)
          else
            normalData.push(Math.round(val.timelineCntNormal / val.periodCntNormal * 100))
          if(val.timelienCntAudit == 0 || val.periodCntAudit == 0)
            auditData.push(0)
          else
            auditData.push(Math.round(val.timelienCntAudit / val.periodCntAudit * 100))
           */
        })
        timelineRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.safetyTalkImplementationRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData
            }
          ]
        }
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiReportBehaviorRate=(type, idx, idx2)=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:'',
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    rateType:type,
    categoryIdx:idx,
    behaviorIdx:idx2,
    isExclude:'N',
    companyIdx:viewCompanyIdx
  }

  //bbs 리포트 카테고리별 통계 (카테고리별,관찰항목별,세부관찰항목별)
  BbsService.getMonitoringStepRate(params).then(
    (response) => {
      let labels = []
      let labelsObj = []
      let normalData = []
      _.forEach(response.result, (val, key)=>{
        if(type == 'category') {
          labels.push(val.categoryTitle?val.categoryTitle:'NA')
          labelsObj.push({categoryIdx:val.categoryIdx, label:val.categoryTitle?val.categoryTitle:'NA'})
        }
        else if(type == 'behavior') {
          labels.push(val.behaviorTitle)
          labelsObj.push({categoryIdx:val.categoryIdx, behaviorIdx:val.behaviorIdx, label:val.behaviorTitle})
        }
        if(type == 'comment') { //todo comment 여러개일경우 테스트필요, 데이터는 behavior_comment group으로 읽어오긴함
          labels.push(val.commentTitle)
          labelsObj.push({commentIdx:val.commentIdx, label:val.commentTitle})
        }
        normalData.push(val.score)
      })
      let barData = {
        labels: labels,
        datasets: [
          {
            label: t('message.safetyBehaviorRate'),
            backgroundColor: '#3C50E0',
            data: normalData
          }
        ],
        labelsObj:labelsObj
      }
      // 한 프레임 뒤에 데이터 바인딩
      requestAnimationFrame(() => {
        if (type == 'category') {
          behaviorStep1BarData.value = barData
          behaviorStep2BarData.value = {}
          behaviorStep3BarData.value = {}
        } else if (type == 'behavior') {
          behaviorStep2BarData.value = barData
          behaviorStep3BarData.value = {}
        } else if (type == 'comment')
          behaviorStep3BarData.value = barData
      })
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiTimelineBehaviorList=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:'',
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    isExclude:'N',
    companyIdx:viewCompanyIdx
  }
  searchParams = params
  //bbs 리포트 안전대화 활동상세
  BbsService.getMonitoringTimelineBehaviorCnt(params).then(
    (response) => {
      let tempItems = []
      _.forEach(response.result, (val, key)=>{
        tempItems.push({action:val.behaviorTitle, safetyTalk:val.timelineTy1Cnt, cheerTalk:val.timelineTy2Cnt, behaviorIdx:val.behaviorIdx})
      })
      timelineBehaviorItems.value = tempItems
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiTimelineMemberList=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:'',
    deptIdx:deptModel.value,
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    isExclude:'N',
    companyIdx:viewCompanyIdx
  }
  searchParams = params
  //bbs 리포트 개인별 활동상세
  BbsService.getMonitoringAnswerMemberCnt(params).then(
    (response) => {
      let tempItems = []
      let tempAnswerCnt = 0
      let tempPeriodCnt = 0
      _.forEach(response.result, (val, key)=>{
        tempItems.push({
          author:`${val.memberName||t('message.noInfo')}(${val.memberId||t('message.noInfo')}) / ${val.posName||t('message.noInfo')} / ${val.deptName||t('message.noInfo')}`,
          monitoring:val.answerCnt,
          safetyTalk:val.timelineCnt,
          submit:dayjs(val.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(val.regDate).format('YYYY-MM-DD'),
          memberIdx:val.memberIdx
        })
        tempAnswerCnt += val.answerCnt
        tempPeriodCnt += val.periodCnt
      })
      memberActivityItems.value = tempItems
      behaviorStep3Cnt.value = tempAnswerCnt
      if(tempAnswerCnt == 0 || tempPeriodCnt == 0)
        behaviorStep3Rate.value = 0
      else
        behaviorStep3Rate.value = Math.round(tempAnswerCnt / tempPeriodCnt * 100)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//레포트 노출정보
const apiMonitoringReportDisplay=()=> {
  const companyIdx = viewCompanyIdx
  BbsService.getMonitoringReportDisplay({companyIdx: companyIdx}).then(
    (response) => {
      //모니터링 노출여부
      reportDisplayInfo.value = response.result
    },
    (error) => {
      if (error.status == 403)
        utils.movePage('/login')
      else {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
const onClickTimelineBehaviorDialog=(idx)=>{
  const user = JSON.parse(localStorage.getItem('user'))
  searchParams.behaviorIdx = idx
  searchParams.memberIdx = '',
    storeRef.popupParams.value = searchParams
  timelineBehaviorDialogModel.value = true
}

const onClickMemberActivityDialog=(idx)=>{
  searchParams.memberIdx = idx
  storeRef.popupParams.value = searchParams
  memberActivityDialogModel.value=true
}

const onClickDate=(type)=>{
  let end = dayjs().endOf('month').format('YYYY-MM-DD')
  let start = dayjs().startOf('month').format('YYYY-MM-DD')
  if(type == 'lastmonth'){
    end = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
    start = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  }
  if(type == 'quarter') {
    end = dayjs().endOf('quarter').format('YYYY-MM-DD')
    start = dayjs().startOf('quarter').format('YYYY-MM-DD')
  }
  else if(type == 'year') {
    end = dayjs().endOf('year').format('YYYY-MM-DD')
    start = dayjs().startOf('year').format('YYYY-MM-DD')
  }

  startDate.value = start.toString()
  endDate.value = end.toString()
}

//리포트 오브젝트 노출여부 설정
const onClickUpdateDisplay=(type, value)=>{
  //레포트 노출정보
  let companyIdx = viewCompanyIdx
  let params = {companyIdx:companyIdx}
  params[type] = value=='Y'?'N':'Y'
  BbsService.updateMonitoringReportDisplay(params).then(
    (response) => {
      //모니터링 노출여부
      reportDisplayInfo.value = response.result
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//{{t('message.filter')}} 메뉴 열고 닫기
const filterDiv1 = ref('off')
const filterOpen1=()=>{
  if(filterDiv1.value == 'off')
    filterDiv1.value = 'on'
  else
    filterDiv1.value = 'off'
}

const onClickInitFilter=()=>{
  startDate.value = ''
  endDate.value = ''
  memberModel.value = ''
  deptModel.value = ''
  posModel.value = ''
  shiftModel.value = ''
  monitoringModel.value = ''
}

const onClickDownloadReport = async ()=>{
  await nextTick() // Vue에서 DOM 그려진 후 실행

  const paper = document.querySelector('.print-page')

  if (paper !== null && paper instanceof HTMLElement) {
    const canvas = await html2canvas(paper, {
      useCORS: true,
      allowTaint: true,
      scale: 2,
      logging: true
    })

    canvas.toBlob(async (blob) => {
      if (blob) {
        const formData = new FormData();
        const file = new File([blob], "report.jpeg", {type: "image/jpeg"});
        formData.append("file", file); // 서버에서 "file" 키로 받을 것
        formData.append("companyIdx", viewCompanyIdx);

        BatchService.sendReport(formData).then(
          (response) => {
            if (response.success) {
              console.log('success')
            }
          },
          (error) => {
            console.log('error')
          }
        )
      }
    })
  }
}

const firstLoading=()=>{
  //본인부서에 해당하는 모니터링, 부서, 맴버정보
  const companyIdx = viewCompanyIdx
  let params2 = {companyIdx: companyIdx, actionType:'1'}
  BbsService.getMonitoringFilter(params2).then(
    (response) => {
      //모니터링{{t('message.filter')}}
      let monitoringList = response.result.monitoringList
      _.forEach(monitoringList, (item)=>{
        monitoringSelect.value.items.push({name:item.monitoringTitle, value:item.idx})
        //if(viewIdx == item.idx)
        //  monitoringModel.value = item.idx
      })
      //부서{{t('message.filter')}}
      let deptList = response.result.deptList
      _.forEach(deptList, (item)=>{
        deptSelect.value.items.push({name:item.treeName, value:item.idx})
      })
      //직책{{t('message.filter')}}
      let posList = response.result.posList
      _.forEach(posList, (item)=>{
        posSelect.value.items.push({name:item.treeName, value:item.idx})
      })
      let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
      response.result.shiftList.forEach((item)=>{
        shiftArr.items.push({name:item.shiftName, value:item.idx})
      })
      shiftSelect.value = shiftArr
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )

  apiMonitoringReportDisplay()
  onClickDate('lastmonth')
  apiReportSummary()
  apiReportRate('frequency')
  apiReportRate('behavior')
  apiReportRate('timeline')
  apiReportBehaviorRate('category','','')
  setTimeout(()=>{apiReportBehaviorRate('behavior', '', '')}, 500)
  apiTimelineBehaviorList()
  apiTimelineMemberList()
}

//watch
/*
watch(loadingCnt, async(newObj) => {
  console.log('loadingCnt:'+loadingCnt.value)
  await nextTick()
  //1개 로딩되고 10초동안 2개 안들어오면 완료
  if(loadingCnt.value == 1) {
    doneTimer = setTimeout(() => {
      window.renderDone = true
    }, 9000)
  }

  if(loadingCnt.value >= 2) {
    clearTimeout(doneTimer)
    setTimeout(() => {
      window.renderDone = true
    }, 5000)
  }
})
 */
</script>


<style lang="scss" >
</style>
